import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import SongCategorySettingsPicker from "../Pickers/SongCategorySettingsPicker";
import { useState } from "react";
import { CardChecklist, CheckLg, PencilFill, TrashFill, XLg } from "react-bootstrap-icons";
import ConfirmPrompt from "../ConfirmPrompt";
import { PLAP_CATEGORY_SIZES } from "../constants";

export default function PlaylistAutopilotSettingsCategoryRow({ virtualizer, item, categories, dataHandlers, onRulesClick, ...props }) {
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const editing = item.status === "EDIT" || item.status === "ADD";

    return (
        <Row className="py-1 border-bottom position-absolute w-100 hoverable-no-pointer" ref={virtualizer.measureElement} {...props}>
            <ConfirmPrompt
                bodyText={
                    <span>
                        Are you sure you want to delete{" "}
                        <span className=" fw-bold">
                            [{item.code}] {item.name}
                        </span>
                        ?
                    </span>
                }
                cancelText="No, go back"
                handleConfirm={async () => await dataHandlers.remove(item)}
                handleClose={() => setShowDeleteConfirm(false)}
                show={showDeleteConfirm}
            />
            <Col xs="2" className=" align-content-center">
                <Row>
                    <Col xs="4">
                        <Form.Control
                            value={item.code}
                            plaintext={!editing}
                            readOnly={!editing}
                            size="sm"
                            className="text-center fw-bold"
                            onChange={e => dataHandlers.change(item, "code", e.target.value)}
                            placeholder={editing ? "P1" : ""}
                        />
                    </Col>
                    <Col xs="8">
                        <Form.Control
                            value={item.name}
                            readOnly={!editing}
                            plaintext={!editing}
                            size="sm"
                            onChange={e => dataHandlers.change(item, "name", e.target.value)}
                            placeholder={editing ? "Power" : ""}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs="6" className=" align-content-center">
                <Row>
                    <Col className=" align-self-center text-center">
                        <Form.Control
                            type="number"
                            min={0}
                            max={new Date().getFullYear()}
                            value={item.min_year ?? ""}
                            plaintext={!editing}
                            readOnly={!editing}
                            size="sm"
                            className="text-center"
                            onChange={e => dataHandlers.change(item, "min_year", e.target.value || null)}
                            placeholder={editing ? "2010" : ""}
                        />
                    </Col>
                    <Col className=" align-self-center text-center">
                        <Form.Control
                            type="number"
                            min={0}
                            max={new Date().getFullYear()}
                            value={item.max_year ?? ""}
                            plaintext={!editing}
                            readOnly={!editing}
                            size="sm"
                            className="text-center"
                            onChange={e => dataHandlers.change(item, "max_year", e.target.value || null)}
                            placeholder={editing ? "2020" : ""}
                        />
                    </Col>
                    <Col className=" align-self-center text-center">
                        <Form.Control
                            type="number"
                            min={0}
                            value={item.relative_min_age ?? ""}
                            plaintext={!editing}
                            readOnly={!editing}
                            size="sm"
                            className="text-center"
                            onChange={e => dataHandlers.change(item, "relative_min_age", e.target.value || null)}
                            placeholder={editing ? "4" : ""}
                        />
                    </Col>
                    <Col className=" align-self-center text-center">
                        <Form.Control
                            type="number"
                            min={1}
                            value={item.relative_max_age ?? ""}
                            plaintext={!editing}
                            readOnly={!editing}
                            size="sm"
                            className="text-center"
                            onChange={e => dataHandlers.change(item, "relative_max_age", e.target.value || null)}
                            placeholder={editing ? "12" : ""}
                        />
                    </Col>
                    <Col xs="2" className=" align-self-center text-center">
                        <Form.Select
                            value={item.size_type}
                            size="sm"
                            readOnly={!editing}
                            onChange={e => dataHandlers.change(item, "size_type", e.target.value)}
                            className=" text-center">
                            {Object.entries(PLAP_CATEGORY_SIZES).map(([value, label]) => (
                                <option key={value} value={value}>
                                    {label}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                    <Col className=" align-self-center text-center">
                        <Form.Control
                            type="number"
                            min={0}
                            value={item.size_type === "target" ? item.target_size ?? "" : ""}
                            plaintext={!editing}
                            readOnly={!editing}
                            disabled={item.size_type !== "target"}
                            size="sm"
                            className="text-center"
                            onChange={e => dataHandlers.change(item, "target_size", e.target.value || null)}
                            placeholder={editing ? "20" : ""}
                        />
                    </Col>
                    <Col xs="3">
                        <Row>
                            <Col xs="6" className=" align-content-center">
                                <Form.Control
                                    type="number"
                                    min={0}
                                    value={item.flexibility_size_absolute ?? ""}
                                    plaintext={!editing}
                                    readOnly={!editing}
                                    size="sm"
                                    className="text-center"
                                    onChange={e => dataHandlers.change(item, "flexibility_size_absolute", e.target.value || null)}
                                    placeholder={editing ? "2" : ""}
                                />
                            </Col>
                            <Col xs="6" className=" align-content-center">
                                <Form.Control
                                    type="number"
                                    min={0}
                                    value={item.flexibility_size_percentage ?? ""}
                                    plaintext={!editing}
                                    readOnly={!editing}
                                    size="sm"
                                    className="text-center"
                                    onChange={e => dataHandlers.change(item, "flexibility_size_percentage", e.target.value || null)}
                                    placeholder={editing ? "10" : ""}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs="3" className=" align-content-center text-center">
                <Row>
                    <Col xs="4" className=" align-self-center">
                        <SongCategorySettingsPicker
                            categories={categories}
                            value={item.move_up_code ?? ""}
                            onChange={e => dataHandlers.change(item, "move_up_code", e.target.value || null)}
                            readOnly={!editing}
                            className=" text-center"
                        />
                    </Col>
                    <Col xs="4" className=" align-self-center">
                        <SongCategorySettingsPicker
                            categories={categories}
                            value={item.move_down_code ?? ""}
                            onChange={e => dataHandlers.change(item, "move_down_code", e.target.value || null)}
                            readOnly={!editing}
                            className=" text-center"
                        />
                    </Col>
                    <Col xs="4" className=" align-self-center">
                        <SongCategorySettingsPicker
                            categories={categories}
                            value={item.move_out_code ?? ""}
                            onChange={e => dataHandlers.change(item, "move_out_code", e.target.value || null)}
                            readOnly={!editing}
                            className=" text-center"
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs="1" className="d-flex justify-content-center">
                <ButtonGroup size="sm">
                    {!editing ? (
                        <>
                            <Button
                                variant="ra-yellow"
                                onClick={onRulesClick}
                                title="Edit Rules"
                                disabled={!(item.move_down_code || item.move_up_code || item.move_out_code)}>
                                <CardChecklist size={20} />
                            </Button>
                            <Button variant="ra-yellow" title="Edit" onClick={() => dataHandlers.toggleEdit(item)}>
                                <PencilFill size={20} />
                            </Button>
                            <Button variant="danger" title="Delete" onClick={() => setShowDeleteConfirm(true)}>
                                <TrashFill size={20} />
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button variant="success" title="Save" onClick={async () => await dataHandlers.save(item)}>
                                <CheckLg size={20} />
                            </Button>
                            <Button variant="danger" title="Discard" onClick={() => dataHandlers.discard(item)}>
                                <XLg size={20} />
                            </Button>
                        </>
                    )}
                </ButtonGroup>
            </Col>
        </Row>
    );
}
